// extracted by mini-css-extract-plugin
module.exports = {"full-width":"style_full-width__2zw4x","fullWidth":"style_full-width__2zw4x","container":"style_container__148jy"};